// @codekit-prepend quiet "js/vendor/slick.js";

// @codekit-prepend quiet "js/components/accordion.js";

// SLICK CONFIG
$('.slider-for').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	dots: true,
	fade: true,
	asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
	arrows: false,
	fade: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	asNavFor: '.slider-for',
	centerMode: true,
	focusOnSelect: true
});

// FILTER LIST WITH SEARCH
function filter(element) {
	var value = $(element)
		.val()
		.toUpperCase();

	$('#courses > li').each(function() {
		if (
			$(this)
				.text()
				.toUpperCase()
				.search(value) > -1
		) {
			$(this).show();
		} else {
			$(this).hide();
		}
	});
}

$('#cpdSearch').keypress(function(cs) {
	if (cs.which === 13) {
		return false;
	} else {
		filter(this);
	}
});
